import { FilesIcon } from '../../icons'
import React, { ReactElement, ReactNode } from 'react'
import { TextTypes } from '../../../types'
import { Text } from '../Text'

export interface EmptyStateProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
    boxed?: boolean
    title?: ReactNode
    icon?: ReactElement
    hideIcon?: boolean
    buttons?: ReactElement
    direction?: 'horizontal' | 'vertical'
    children: string | ReactElement | ReactElement[]
}

export const EmptyState = ({
    boxed = true,
    title,
    icon,
    hideIcon = false,
    buttons,
    direction = 'horizontal',
    children,
    ...props
}: EmptyStateProps): ReactElement => {
    const defaultClasses = 'empty-state flex py-6 gap-2 items-center'
    const boxedClasses = boxed ? 'bg-empty-state px-6' : ''
    const directionClasses = direction === 'vertical' ? 'flex-col text-center' : ''
    const propClasses = props.className ?? ''
    const combinedClasses = [defaultClasses, boxedClasses, directionClasses, propClasses].join(' ')

    const iconElement = icon ? icon : <FilesIcon />

    return (
        <div {...props} className={combinedClasses} data-testid="empty-state">
            {(!hideIcon || icon) && <div className="empty-state__icon mb-auto text-shade-300">{iconElement}</div>}
            <div className="inline-flex flex-col">
                {title && <Text type={TextTypes.HEADING_4}>{title}</Text>}
                <Text className="text-text-secondary">{children}</Text>
                {buttons && (
                    <div className={`mt-3 inline-flex gap-4 ${direction === 'vertical' ? 'justify-center' : ''}`}>
                        {buttons}
                    </div>
                )}
            </div>
        </div>
    )
}
